import React, { FC } from 'react';
import SimpleModal from '../../../components/modals/SimpleModal/SimpleModal';

interface TroubleshootingModalProps {
	show: boolean;
	onClose: () => void;
}
const TroubleshootingModal: FC<TroubleshootingModalProps> = ({
	show,
	onClose,
}) => {

	return (
		<SimpleModal
			show={show}
			size="lg"
			title="Troubleshooting: Missing Products or Components"
			closeModal={onClose}
		>
			<div>

				<section>
					<h3>All order purposes:</h3>
					<ul>
						<li>
							Product not available –
							<ul>
								<li>The product hasn’t progressed far enough in NCMS to be available. Check your product’s Digital Catalog tab for the Main Title. Development and NCMS entries may need to progress for the product to be shown.</li>
								<li>The Digital Distribution Rights are assigned to another company. Check the distribution rights on your product’s Product Summary tab. Correct the rights or have the distribution owner place the order.</li>
							</ul>
						</li>
						<li>
							Component not available –
							<ul>
								<li>The product can be selected but a Bundle or Other Component isn’t available to select. Check your product’s Digital Catalog tab for the Bundle or Other Components. Your item might not be associated with the product. Contact Nintendo to complete a manual association.</li>
							</ul>
						</li>
					</ul>
				</section>

				<section>
					<h3>Code-in-Box orders:</h3>
					<ul>
						<li>
							A pricing method for the item hasn’t been set. Navigate to your product’s Digital Catalog page to determine a pricing method and set the price. Your selections will need to be approved by Nintendo before the price is available.
						</li>
					</ul>
				</section>

				<section>
					<h3>Premium SKU, Investor Rewards, Codes for resale:</h3>
					<ul>
						<li>
							The item has a $0 price in NCMS. Items with a $0 price in NCMS are not valid for these purposes. Change the permanent price in NCMS or use a different purpose, Bonus Content or Marketing Codes.
						</li>
						<li>
							A permanent price hasn’t been set in NCMS. Check your product’s Digital Catalog page, if no price is shown, the permanent price isn’t available yet. You can declare a price by selecting the {'>'} on the item. Note that NCMS entries with presales will not reflect the price until the presale has ended.
						</li>
					</ul>
				</section>

				<section>
					<h3>Don’t see your issue listed here? Use the Contact Site Support option for help.</h3>
				</section>

			</div>
		</SimpleModal>
	);
};

export default TroubleshootingModal;
